import { Trait } from '../../trait.type';
import { TraitRegistry, TraitType } from '../../trait-registry';
import { StatusEffect } from '../../status-effects.type';
import type { Damage } from '../../damage.type';

export class WarriorTrait extends Trait {
  static baseType = TraitType.Warrior;
  static baseTitle = "Warrior's Smash";
  static baseText = 'If the enemy is Stunned, deal 2 extra damage.';
  static baseIcon = 'trait';

  type = WarriorTrait.baseType;
  title = WarriorTrait.baseTitle;
  text = WarriorTrait.baseText;
  icon = WarriorTrait.baseIcon;

  damageOut(damage: Damage): void {
    const stun = this.owner.statusEffects.find(
      (modifier: any) => modifier.type === StatusEffect.Stunned,
    );
    if (stun) {
      damage.value += 2;
    }
  }
}

TraitRegistry.register(WarriorTrait.baseType, WarriorTrait);
